import { Button, ButtonClean, List, Loader, Subsection } from '@fourthwall/components';
import React from 'react';
import { PublicTokenListItem } from './components/PublicTokenListItem/PublicTokenListItem';
import * as S from './Headless.styled';
import { useHeadless } from './hooks/useHeadless';
export const Headless = () => {
    const { handlePublicTokenCreate, handlePublicTokenDelete, loading, publicTokens } = useHeadless();
    return (React.createElement(Subsection, { title: "Storefront Token" },
        React.createElement(S.ContentContainer, null,
            React.createElement("div", null,
                "Build a fully custom storefront for your brand on any platform you choose, powered by our Storefront API.",
                ' ',
                React.createElement(ButtonClean, { label: "Learn more", href: "https://docs.fourthwall.com/storefront", target: "_blank" })),
            React.createElement(S.ActionsContainer, null,
                React.createElement("div", null,
                    React.createElement(Button, { label: "Create token", size: "small", onClick: handlePublicTokenCreate })),
                loading && React.createElement(Loader, null),
                !loading && !!publicTokens.length && (React.createElement(List, { data: publicTokens, renderItem: (token) => (React.createElement(PublicTokenListItem, { ...token, onDelete: handlePublicTokenDelete })) }))))));
};
